var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rounded pa-3 max-width",
      style: {
        border: _vm.disabled
          ? "none"
          : !_vm.isError
          ? "2px dashed var(--main-border-color)"
          : "2px dashed red",
      },
      on: { dragover: _vm.fileDragover, drop: _vm.fileDrop },
    },
    [
      _vm.fileList.length == 0 && _vm.disabled
        ? _c("v-sheet", { staticClass: "text--secondary" }, [
            _vm._v(
              _vm._s(_vm.$t("label_essweb_update_components_noContentLabel"))
            ),
          ])
        : _vm._e(),
      _c("v-file-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        attrs: { id: "fileInput", "hide-input": "" },
        on: { change: _vm.chooseUploadFile },
      }),
      _vm.fileList.length
        ? _c(
            "v-sheet",
            { staticClass: "text-left align-center" },
            _vm._l(_vm.fileList, function (item, index) {
              return _c(
                "v-list-item",
                {
                  key: item.id,
                  staticClass: "rounded mt-2 pt-2 pb-2",
                  staticStyle: { border: "1px solid var(--main-border-color)" },
                  attrs: { "two-line": "" },
                },
                [
                  _c(
                    "v-list-item-avatar",
                    {
                      staticClass: "pa-0 pt-2 pb-2 mt-0 mb-0",
                      attrs: { size: "80", tile: "" },
                      on: {
                        click: function ($event) {
                          _vm.curImageIndex = index
                          _vm.showImageBox = true
                        },
                      },
                    },
                    [
                      !item.updated
                        ? _c("svg-icon", {
                            attrs: {
                              size: "72",
                              fill: "grey",
                              iconClass: "photo",
                            },
                          })
                        : _vm._e(),
                      item.updated
                        ? _c("v-img", { attrs: { src: item.imageUrl } })
                        : _vm._e(),
                      item.uploading
                        ? _c(
                            "v-sheet",
                            {
                              staticClass:
                                "d-flex text-center align-center justify-center white--text",
                              staticStyle: {
                                position: "absolute",
                                background: "rgba(0, 0, 0, 0.4)",
                                "font-size": "12px",
                              },
                              attrs: { width: "100%", height: "100%" },
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  rotate: 10,
                                  size: 24,
                                  width: 2,
                                  color: "primary",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [_vm._v(_vm._s(item.filename))]),
                      _c(
                        "v-list-item-subtitle",
                        [
                          _c("v-chip", { attrs: { "x-small": "" } }, [
                            _vm._v(_vm._s(_vm.$byteconvert(item.size))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.disabled
                    ? _c(
                        "v-list-item-action",
                        [
                          item["save"] !== true
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { small: "", icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteItem(item.id, item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons-round" },
                                    [_vm._v("delete")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      (_vm.single ? _vm.fileList.length == 0 : true)
        ? _c("v-sheet", { staticClass: "text-center align-center" }, [
            _vm.fileList.length == 0 && !_vm.disabled
              ? _c("div", [
                  _c(
                    "i",
                    {
                      staticClass:
                        "material-icons-round md-72 text--secondary lighten-2",
                    },
                    [_vm._v("backup")]
                  ),
                ])
              : _vm._e(),
            !_vm.disabled
              ? _c(
                  "div",
                  { staticClass: "pt-3" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("label_essweb_update_components_tipLabel")
                        )
                      ),
                    ]),
                    _c(
                      "v-btn",
                      {
                        staticClass: "text-capitalize ml-2",
                        attrs: {
                          color: "primary lighten-2 ",
                          small: "",
                          rounded: "",
                        },
                        on: { click: _vm.toChoose },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "label_essweb_update_components_browseBtnLabel"
                            )
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _c("LightBox", {
        attrs: {
          show: _vm.showImageBox,
          index: _vm.curImageIndex,
          imageList: _vm.imageList,
        },
        on: {
          close: function ($event) {
            _vm.showImageBox = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }